import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import { useMemo, useRef } from 'react';
import { TypeByError } from '../../factories/ContextQuery/QueryParamSelectors/typeByError';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const typeByErrorWidget = () => {
    const lastQueryParamsRef = useRef(undefined);
    const component = useMemo(() => (_jsxs(Stack, { gap: 1, children: [_jsx(Typography, { variant: "h5", children: "TypeByError" }), _jsx(TypeByError, { attKey: "", attKey2: "", type: '', updateParams: () => { }, index: 0, children: undefined, selected: false, keyPress: () => { }, lastQueryParamsRef: lastQueryParamsRef, lastQuery: undefined, clearSelectedObjects: () => { } })] })), []);
    return {
        name: 'typeByError',
        category: 'composite',
        component,
    };
};
